import { Button } from './ui/button';
import DecisionBadge from './DecisionBadge';
import { Check, Pencil } from 'lucide-react';

const DecisionRow = ({
  label,
  value,
  type = 'recommended',
  rationale,
  onConfirm,
  onEdit,
  confirmLabel = 'Bevestigen',
  editLabel = 'Wijzigen',
  confirmed = false,
  children,
  className = '',
}) => {
  return (
    <div
      className={`p-4 rounded-xl border transition-colors ${
        confirmed
          ? 'bg-green-50/50 border-green-200'
          : type === 'required'
            ? 'bg-amber-50/30 border-amber-200'
            : type === 'recommended'
              ? 'bg-blue-50/30 border-blue-100'
              : 'bg-neutral-50 border-neutral-100'
      } ${className}`}
      data-testid={`decision-row-${label?.toLowerCase().replace(/\s+/g, '-') || 'item'}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1 flex-wrap">
            <span className="text-xs font-bold text-neutral-500 uppercase tracking-wider">{label}</span>
            {!confirmed && <DecisionBadge type={type} />}
            {confirmed && (
              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-green-100 text-green-700 border border-green-200" data-testid="decision-confirmed-badge">
                <Check className="h-3 w-3" strokeWidth={2.5} />
                Bevestigd
              </span>
            )}
          </div>
          {value && (
            <p className="text-sm font-medium text-black mt-1">{value}</p>
          )}
          {children}
          {rationale && (
            <p className="text-[11px] text-neutral-500 mt-1.5 leading-relaxed">{rationale}</p>
          )}
        </div>
        {!confirmed && (onConfirm || onEdit) && (
          <div className="flex items-center gap-2 shrink-0 pt-1">
            {onConfirm && (
              <Button
                size="sm"
                className="bg-black text-white hover:bg-neutral-800 h-7 text-xs px-3"
                onClick={onConfirm}
                data-testid="decision-confirm-btn"
              >
                <Check className="h-3 w-3 mr-1" strokeWidth={2} />
                {confirmLabel}
              </Button>
            )}
            {onEdit && (
              <Button
                variant="ghost"
                size="sm"
                className="text-neutral-500 hover:text-black h-7 text-xs px-2"
                onClick={onEdit}
                data-testid="decision-edit-btn"
              >
                <Pencil className="h-3 w-3 mr-1" strokeWidth={1.5} />
                {editLabel}
              </Button>
            )}
          </div>
        )}
        {confirmed && onEdit && (
          <Button
            variant="ghost"
            size="sm"
            className="text-neutral-400 hover:text-black h-7 text-xs px-2 shrink-0"
            onClick={onEdit}
            data-testid="decision-edit-btn"
          >
            <Pencil className="h-3 w-3 mr-1" strokeWidth={1.5} />
            {editLabel}
          </Button>
        )}
      </div>
    </div>
  );
};

export default DecisionRow;
